module.exports = (__webpack_require__(20399))("./node_modules/worker-timers/build/es5/bundle.js");